import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessage } from '@fortawesome/free-solid-svg-icons';
import NewEmailToast from './NewEmailToast';

const TOAST_ID = 'EMAIL_TOST_ID';

const useNewEmails = (emails) => {
  const timerId = useRef(null);

  useEffect(
    () => {
      const checker = () => {
        const newEmails = emails.filter((obj) => obj.read === false);
        if (newEmails.length) {
          toast.success(NewEmailToast, {
            theme: 'colored',
            toastId: TOAST_ID,
            icon: () => (
              <FontAwesomeIcon icon={faMessage} size="xl" />
            ),
          });
        }
        timerId.current = setTimeout(checker, 10 * 60 * 1000); // 10 минут
      };
      checker();
      return () => clearTimeout(timerId.current);
    },
    [emails],
  );
};

export default useNewEmails;
